import request from 'superagent';
import i18next from 'i18next';
import AdminServerActionCreators from '../actions/AdminServerActionCreators';
import client from './rest/AdminClient';
import SessionStore from '../stores/SessionStore';
import { getBearerGrantTypeAuthHeaders } from '../helpers/auth_helpers';
import axios from 'axios';
import UserWebAPIUtils from 'utils/UserWebAPIUtils';

const login = (username, password) =>
  client({
    method: 'POST',
    path: '/v2/users/login',
    entity: JSON.stringify({ username, password }),
  });

const requestPasswordReset = (email) =>
  client({
    method: 'POST',
    path: '/users/passwordreset',
    entity: JSON.stringify({ email }),
  });

const resetPassword = (token, password, createPassword = false) =>
  client({
    method: 'POST',
    path: `/users/password-reset/${token}`,
    entity: JSON.stringify({ password, createPassword }),
  });

const verifyUserToken = async (token) => {
  const url = `${AUTH_SERVICE_HOST}/api/auth/validate/token`;
  const options = {
    method: 'POST',
    url,
    headers: {},
    data: { token },
  };
  return axios(options);
};

const getUserById = async (id) => {
  return UserWebAPIUtils.getV2(id);
};

export default {
  async checkAuthToken(callback) {
    try {
      const token = SessionStore.getToken();
      const user = SessionStore.getUser();

      if (!token) {
        AdminServerActionCreators.authCheckFailed();
        return callback();
      }

      const { data } = await verifyUserToken(token);

      if (!data?.isValid) {
        AdminServerActionCreators.authCheckFailed();
        return callback();
      }

      let authenticatedUser = user;
      if (user?._type === 'Carrier') {
        authenticatedUser = await getUserById(user?._id);
      }

      AdminServerActionCreators.authCheckSuccess({ user: authenticatedUser });
      return callback(authenticatedUser);
    } catch (error) {
      console.error('Auth token check failed: ', error);
      AdminServerActionCreators.authCheckFailed();
      callback();
    }
  },
  async login(username, password) {
    try {
      const { status, entity } = await login(username, password).catch((e) => {
        throw e;
      });

      if (status && status.code !== 200) {
        return AdminServerActionCreators.loginFail(
          i18next.t('INVALID_CREDENTIALS'),
        );
      }

      if (entity.success) {
        const { user, token } = entity;
        AdminServerActionCreators.loginSuccess(token, user);
      } else {
        AdminServerActionCreators.loginFail(i18next.t('INVALID_CREDENTIALS'));
      }
    } catch (e) {
      console.log('error: ', e);
      AdminServerActionCreators.loginFail(i18next.t('INVALID_CREDENTIALS'));
    }
  },
  resetPassword(token, password, createPassword) {
    resetPassword(token, password, createPassword)
      .then((res) => {
        if (res.entity.success) {
          const response = i18next.t('PASSWORD_CHANGED');
          AdminServerActionCreators.receivePasswordChangeSuccess(response);
        } else {
          const response =
            res?.entity?.message || i18next.t('PASSWORD_UPDATE_FAILED');
          AdminServerActionCreators.receivePasswordChangeFailure(response);
        }
      })
      .catch((err) => {
        console.log(err.stack || err);
        const response =
          err?.entity?.message || i18next.t('SOMETHING_WENT_WRONG');
        AdminServerActionCreators.receivePasswordChangeFailure(response);
      });
  },
  requestPasswordReset(email) {
    requestPasswordReset(email).then(
      (response) => {
        AdminServerActionCreators.receivePasswordResetRequestSuccess(
          response.entity.message,
        );
      },
      (response) => {
        AdminServerActionCreators.receivePasswordResetRequestFailure(
          response.entity.message,
        );
      },
    );
  },
  uploadEmptyReturnInstructions(files) {
    return new Promise((resolve, reject) => {
      const req = request.post(`${API_HOST}/admin/api/instructions/empty`);
      req.set('Authorization', getBearerGrantTypeAuthHeaders());
      files.forEach((file) => {
        req.attach('pageDataFile', file);
      });
      req.end((err, res) => {
        if (err) {
          reject(res);
        }
        if (res.body.success) {
          resolve(res.body);
        } else {
          reject(res);
        }
      });
    });
  },
};
